export default __webpack_public_path__ + "static/media/SJA1540.34I-42417_-25416_0.6f7aca2d.jpg";